export default "__VITE_ASSET__84a162e2__"